import type z from 'zod/v4'
import { relations } from 'drizzle-orm'
import { index, pgTable, primaryKey, uuid } from 'drizzle-orm/pg-core'
import { createInsertSchema, createSelectSchema, createUpdateSchema } from 'drizzle-zod'

import { Keyword } from '../keyword'
import { Book } from './book'

export const BookToKeyword = pgTable(
  'book_to_keyword',
  {
    bookId: uuid()
      .notNull()
      .references(() => Book.id, { onDelete: 'cascade' }),
    keywordId: uuid()
      .notNull()
      .references(() => Keyword.id, { onDelete: 'cascade' }),
  },
  (table) => [
    primaryKey({ columns: [table.bookId, table.keywordId] }),
    index('book_to_keyword_book_idx').on(table.bookId),
    index('book_to_keyword_keyword_idx').on(table.keywordId),
  ],
)

export const bookToKeywordRelations = relations(BookToKeyword, ({ one }) => ({
  book: one(Book, {
    fields: [BookToKeyword.bookId],
    references: [Book.id],
  }),
  keyword: one(Keyword, {
    fields: [BookToKeyword.keywordId],
    references: [Keyword.id],
  }),
}))

export const InsertBookToKeywordSchema = createInsertSchema(BookToKeyword)
export const UpdateBookToKeywordSchema = createUpdateSchema(BookToKeyword).partial()
export const SelectBookToKeywordSchema = createSelectSchema(BookToKeyword)

export type InsertBookToKeyword = typeof BookToKeyword.$inferInsert
export type UpdateBookToKeyword = z.infer<typeof UpdateBookToKeywordSchema>
export type SelectBookToKeyword = typeof BookToKeyword.$inferSelect
